import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

export interface Basket {
    status: BasketStatus;
    spot_id: string | null;
    cost_center_id: string | null;
    update_timestamp: string;
    id: string;
    account_id: string;
    user_id: string;
    creation_timestamp: string;
}

export interface CreateBasket {
    status?: BasketStatus;
    spot_id?: string | null;
    cost_center_id?: string | null;
}

export interface UpdateBasket {
    null_fields?: string[];
    status?: BasketStatus;
    spot_id?: string | null;
    cost_center_id?: string | null;
}

export interface CheckoutBasket {
    spot_id?: string;
    order_workflow_id?: string;
}

export enum BasketStatus {
    OPEN = 'open',
    CHECKED_OUT = 'checked_out'
}

enum QueryParams {
    STATUS = 'status',
    SPOT_ID = 'spot_id',
    USER_ID = 'user_id'
}

export type BasketListResponse = PaginatedResponse<Basket>;
export type BasketQueryParams = DefaultQueryParams & QueryParams;
